import { User } from 'firebase/auth'
import { create } from 'zustand'

interface IAuthStore {
  user: User | null
  isLoading: boolean
}

const authStore = create<IAuthStore>()(() => ({
  user: null,
  isLoading: true,
}))

export default authStore
